import { ReactNode } from "react";

/** Filter controls above a table. Below md they sit two to a row, since one per row took most of a phone's height. */
export const FilterBar = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col w-full items-center fade-up">
    <div className="container overflow-y-hidden">
      <div className="bg-theme-surface-2 px-2 py-3 compact:py-1.5 border border-theme-table-border mb-4 compact:mb-2 shadow text-theme-text">
        <div className="grid grid-cols-2 gap-2 md:flex md:flex-wrap md:gap-4 compact:gap-2">
          {children}
        </div>
      </div>
    </div>
  </div>
);

type FilterFieldProps = {
  label: string;
  children: ReactNode;
  className?: string;
};

/** The heading is dropped on compact screens, where the control's own floating label already names it. */
export const FilterField = ({ label, children, className }: FilterFieldProps) => (
  <div className={`flex flex-col items-center gap-2 compact:gap-0 min-w-0 ${className ?? ''}`}>
    <label className="text-2xl compact:hidden">{label}</label>
    {children}
  </div>
);

type FilterCheckboxProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  title?: string;
  className?: string;
};

/** Keeps its label on compact screens, beside the box rather than over it: a bare checkbox has nothing else naming it. */
export const FilterCheckbox = ({ label, checked, onChange, title, className }: FilterCheckboxProps) => (
  <label title={title} className={`flex flex-col compact:flex-row items-center justify-center gap-2 cursor-pointer ${className ?? ''}`}>
    <span className="text-2xl compact:text-base">{label}</span>
    <input
      type="checkbox"
      checked={checked}
      className="w-8 h-8 compact:w-6 compact:h-6 border-theme-border rounded-md focus:ring-blue-500 focus:ring-2"
      onChange={(e) => onChange(e.target.checked)}
    />
  </label>
);
